if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile) return;

  const tileHover = tile.querySelector('.product-tile__hover');
  if (tileHover) {
    const productTileHoverSize = tile.querySelector('.product-tile__hover__size__options-wrapper');
    if(productTileHoverSize) {
      new Swiper(tile.querySelector('.product-tile__hover__size__options-wrapper'), {
        loop: false,
        slidesPerView: 9,
        spaceBetween: 8,
        navigation: {
          nextEl: tile.querySelector('.product-tile__hover__size__option__arrow.right'),
          prevEl: tile.querySelector('.product-tile__hover__size__option__arrow.left'),
        },
      });
    }

    const productTileHoverImages = tile.querySelector('.product-tile__hover__variants__images-wrapper');
    if(productTileHoverImages) {
      new Swiper(tile.querySelector('.product-tile__hover__variants__images-wrapper'), {
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 4,
        navigation: {
          nextEl: tile.querySelector('.product-tile__hover__variants__image__arrow.right'),
          prevEl: tile.querySelector('.product-tile__hover__variants__image__arrow.left'),
        }
      });
    }
  }
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
    window.dAgency.initProductTile(tile);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
      window.dAgency.initProductTile(tile);
    });
  });
}

window.addEventListener('tile_swiper', function (evt) {
  [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
    window.dAgency.initProductTile(tile);
  });
});
